import { Paper } from '@mui/material';
import React from 'react';
import {
  FuturePrice,
  FuturePricesList,
  useGetFuturePrice,
} from 'src/entities/future-price';
import { useRouter } from 'src/hooks/useRouter';

interface Props {}

export const FuturePricePage: React.FunctionComponent<Props> = ({}) => {
  const router = useRouter();

  console.log(router.query);

  const priceRequest = useGetFuturePrice({
    variables: {
      id: router.query.futurePriceId as string,
    },
    skip: !router.query.futurePriceId,
  });

  return (
    <div>
      <Paper>
        <FuturePrice price={priceRequest.data?.data} />
      </Paper>
    </div>
  );
};
